// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Link from "../Link.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as StatsConfig from "./StatsConfig.bs.js";
import * as TraitOverview from "./TraitOverview.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

var box = CssJs.style([
      CssJs.alignItems("center"),
      CssJs.margin(CssJs.px(9)),
      CssJs.padding(CssJs.px(6)),
      CssJs.height(CssJs.px(60)),
      CssJs.width(CssJs.px(192)),
      CssJs.wordBreak(CssJs.breakAll),
      CssJs.border(CssJs.px(1), CssJs.solid, CssJs.white),
      CssJs.cursor("pointer")
    ]);

var Styles = {
  box: box
};

function TraitPage(Props) {
  var traitId = Props.traitId;
  var traitRank = Props.traitRank;
  var traitData = Props.traitData;
  var set = TftSet.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var minUnitCount = Sd.traitRankUnitCount(traitId, traitRank, set);
  Dict.getExn(Data.traits(set), traitId);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement("div", {
                        className: "flex-1 sm:w-[576px] md:w-[842px]"
                      }, React.createElement(ContentSection.make, {
                            className: "mb-4",
                            children: React.createElement("div", {
                                  className: "flex items-center"
                                }, React.createElement("h4", {
                                      className: "ml-2 font-medium text-2xl pr-3"
                                    }, String(minUnitCount) + " ", React.createElement(TraitName0.make, {
                                          trait: traitId
                                        })), Belt_Array.mapWithIndex(Sd.traitRankCounts(traitId, set), (function (idx, param) {
                                        var rank = idx + 1 | 0;
                                        return React.createElement(Link.make, {
                                                    route: {
                                                      TAG: /* Stats */0,
                                                      _0: {
                                                        TAG: /* Trait */5,
                                                        trait: traitId,
                                                        rank: rank,
                                                        aperture: aperture
                                                      }
                                                    },
                                                    children: React.createElement("div", {
                                                          className: "p-1 ml-1 cursor-pointer" + (
                                                            traitRank === rank ? "" : " opacity-30"
                                                          )
                                                        }, React.createElement(TraitImage.PlainIcon2.make, {
                                                              traitId: traitId,
                                                              rank: rank,
                                                              size: 36
                                                            }))
                                                  });
                                      })))
                          }), React.createElement(TraitOverview.Inner.make, {
                            traitStats: traitData
                          }))
                }));
}

var make = TraitPage;

export {
  Styles ,
  make ,
  
}
/* box Not a pure module */
